import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const LogOut = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogout = () => {
    setIsSubmitting(true)
    // Remove user data from local storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("userName");
    localStorage.removeItem("userType");
    localStorage.removeItem("userId");
    localStorage.removeItem("userImage");
    localStorage.removeItem("cart");

    // Show logout success message
    toast.success("Logged out successfully!", { duration: 1000 });

    setIsSubmitting(false);
    navigate("/");
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px]  relative">
          <h2 className="text-xl font-semibold mb-5 text-G500 text-center">
            Are you sure you want to log out?
          </h2>
          {/* Buttons */}
          <div className="flex justify-center space-x-4 mt-14">
            <button
              type="button"
              onClick={onClose}
              className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green "
            >
              Cancel
            </button>
            <button
              onClick={handleLogout}
              className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting
                ? "bg-green50 cursor-not-allowed"
                : "bg-green text-white"
                }`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Logging out..." : "Log Out"}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default LogOut;
